import {
  Account,
  useDispatchDeleteAccountScriptJobMutation,
} from "../../../generated/graphql";
import { useStatusToasts } from "../../../hooks/useStatusToasts";
import { getDefaultDeleteBody, useDeleteModal } from "../../Common/DeleteModal";

export const useDeleteAccountModal = (
  account: Maybe<Pick<Account, "id" | "name">>,
) => {
  const { addSuccessToast, addErrorToast } = useStatusToasts();

  const [deleteAccount] = useDispatchDeleteAccountScriptJobMutation({
    onCompleted: () => {
      addSuccessToast("Account deletion has been scheduled.");
    },
    onError: error => {
      addErrorToast(
        error.message ||
          "There was a problem scheduling account deletion. Please try again or contact support@withforerunner.com",
      );
    },
  });

  const [showDeleteModal] = useDeleteModal({
    headerText: "Delete account",
    subheaderText: account?.name,
    Content: getDefaultDeleteBody("account"),
    deleteButtonText: "Delete",
    size: "medium",
    onDelete: () => {
      if (account) {
        void deleteAccount({
          variables: { data: { accountId: account.id } },
        });
      }
    },
    dependencies: [account],
  });

  return showDeleteModal;
};
